<template>
  <table-layout title="سطل زباله" :showSearch="false">
    <template #buttons>

      <router-link v-if="contentType=='posts'" :to="{ name: 'PostsDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست پست ها</b-button>
      </router-link>

      <router-link v-else-if="contentType=='pages'" :to="{ name: 'PagesDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست برگه ها</b-button>
      </router-link>

      <router-link v-else-if="contentType=='lesson'" :to="{ name: 'LessonsDashboard' }" class="ml-2">
        <b-button pill variant="purple"> بازگشت به صفحه لیست درس ها</b-button>
      </router-link>

    </template>
    <template #table>
      <tabel-items :items="TrashContents" :restoreState="true"/>
    </template>
  </table-layout>
</template>

<script>
import TableLayout from "../TableLayout.vue";
import tabelItems from "./tableItems.vue";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {mapGetters} from "vuex";

export default {
  name: "trashItems",
  components: {TableLayout, tabelItems},
  data() {
    return {
      tableAttributes,
    };
  },
  computed: {
    ...mapGetters({
      'TrashContents': "Content/getTrashContents",
    }),
    contentType() {
      return this.$router.currentRoute.params.type
    }
  },
  mounted() {
    this.$store.dispatch("Content/getTrashContents")

  }
};
</script>